import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
const config = require(`../../../projects/${process.env.PROJECT}/front/configs/envs/${process.env.NODE_ENV}/config.json`)

axios.defaults.headers.common = {
  'flexy-country': config['flexy-country'],
  'flexy-city': config['flexy-city'],
  'site-source': config['site-source'],
  'flexy-reparto': config['flexy-reparto'],
  'X-Flexy-Development': 'https://localhost:4200'
}

Vue.use(VueAxios, axios)



// WEBPACK FOOTER //
// ./src/front/init/utils/axios.js